import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { BadgeComponent } from '@bizzdesign/ui-badge';
import { AccordionModule } from 'primeng/accordion';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'bd-ai-accordion-header',
  standalone: true,
  imports: [BadgeComponent, AccordionModule, ButtonModule],
  templateUrl: './ai-accordion-header.component.html',
  styleUrl: './ai-accordion-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AiAccordionHeaderComponent {
  icon = input.required<string>();
  title = input.required<string>();
  answered = input(false);

  /** Indicates whether the chat history panel is visible. */
  historyOpen = input(false);

  /** Provides the label displayed in the visible chat history panel. */
  historyTitle = input('');
}
